// Pure helpers for the Department section of the Users tab rail.
//
// The rail's counts and the row filter must agree on which departments a user
// belongs to, or a count promises rows that selecting it doesn't show. Both go
// through userDeptIds: the primary `department_id` plus every `departments[]`
// entry (membership or management), deduplicated so a user is counted once.

export function userDeptIds(u) {
  const ids = new Set();
  if (!u) return ids;
  if (u.department_id != null) ids.add(u.department_id);
  for (const d of (u.departments || [])) {
    if (d && d.id != null) ids.add(d.id);
  }
  return ids;
}

/** { [deptId]: number } over the given users. */
export function countByDept(users) {
  const out = {};
  for (const u of users || []) {
    for (const id of userDeptIds(u)) out[id] = (out[id] || 0) + 1;
  }
  return out;
}
